export default {
  sessionState: Object.freeze({
    IS_ONLINE_LOCAL_STORAGE_KEY: 'is-online', LAST_ACTION_LOCAL_STORAGE_KEY: 'last-action'
  }),
}
